export default function preventReload() {
    window.onbeforeunload = () => "";
    return () => { window.onbeforeunload = null };
}